// import { HeadProvider, Title, Link, Meta } from "react-head";
import { Helmet } from "react-helmet";
import Hero from "./component/Hero";
import Navbar from "./component/Navbar";
import SocialLinks from "./component/SocialLinks";
import About from "./component/About";
import Experience from "./component/Experience";
import Projects from "./component/Projects";
import Contact from "./component/Contact";
import Footer from "./component/Footer";
import { dataObjects } from "./data/projectData";
import logo from "../src/assets/logo.ico";

function App() {
  return (
    <div className=" bg-[#0a192f] w-full text-[#ccd6f6] font-[Karla]">
      <Helmet>
        <title>Qozeem Opeyemi</title>
        <meta name="description" content="Qozeem Opeyemi's portfolio website" />
        <meta
          name="keywords"
          content="Qozeem, Salami, frontend, web development"
        />
        <link rel="shortcut icon" type="image/x-icon" href={logo} />
      </Helmet>

      <Navbar />
      <div className="px-[20px] md:px-[50px]  ">
        <Hero />
        <About />
        <Experience />

        {/* project showcase */}

        <div className=" mb-[200px]">
          <div className="flex items-center gap-2 md:gap-4 justify-center md:justify-start">
            <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
            <h3 className="text-center md:text-left font-bold text-2xl md:text-4xl mb-[10px] md:mb-[30px]">
              My Projects
            </h3>
            <div className="w-[10%] h-0.5 bg-[#ccd6f6] rounded-full"></div>
          </div>
          {dataObjects.map((project) => (
            <Projects
              key={project.id}
              id={project.id}
              img={project.img}
              name={project.name}
              description={project.description}
              tools={project.tools}
              github={project.github}
              host={project.host}
            />
          ))}{" "}
        </div>

        <Contact />
        <Footer />
        <SocialLinks />
      </div>
    </div>
  );
}

export default App;
